import { SecurityHelper } from '../helpers.js';

// Schema:
//   { type: 'table', columns: ['col1', 'col2'], rows: [['a','b'], ['c','d']] }
export function renderTable(block) {
  const columns = Array.isArray(block.columns) ? block.columns : [];
  const rows = Array.isArray(block.rows) ? block.rows : [];

  const wrapper = document.createElement('div');
  wrapper.className = 'cyx-block cyx-block-table';

  const scroller = document.createElement('div');
  scroller.className = 'cyx-block-table-scroller';

  const table = document.createElement('table');
  table.className = 'cyx-block-table-el';

  if (columns.length > 0) {
    const thead = document.createElement('thead');
    const tr = document.createElement('tr');
    for (const col of columns) {
      const th = document.createElement('th');
      th.textContent = String(col);
      tr.appendChild(th);
    }
    thead.appendChild(tr);
    table.appendChild(thead);
  }

  const tbody = document.createElement('tbody');
  for (const row of rows) {
    if (!Array.isArray(row)) continue;
    const tr = document.createElement('tr');
    for (const cell of row) {
      const td = document.createElement('td');
      // Cells may legitimately contain short text — escape via textContent so
      // any markup is rendered literally and cannot inject DOM. Null/undefined
      // become an empty string; other falsy values (0, false) render verbatim.
      td.textContent = String(cell ?? '');
      tr.appendChild(td);
    }
    tbody.appendChild(tr);
  }
  table.appendChild(tbody);

  scroller.appendChild(table);
  wrapper.appendChild(scroller);

  // Reference SecurityHelper so the import is preserved if future iterations
  // need to render HTML inside cells.
  void SecurityHelper;

  return wrapper;
}
